import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import CachedRoundedIcon from '@mui/icons-material/CachedRounded';
export const MixedGameLabel = ({ label, color, marginRight = 3 }) => (_jsxs("div", { css: css `
      color: ${color};
      display: flex;
      flex-direction: row;
      align-items: center;
    `, children: [_jsx(CachedRoundedIcon, { css: css `
        margin-right: ${marginRight}px;
      ` }), label] }));
